export default "__VITE_ASSET__d1fdc216__"